import * as React from "react";
export interface MessageProps {
    content: string;
    width: string;
    fontColor?: string;
    textAlign?: any;
}

export class MessageComponent extends React.Component<MessageProps, {}> {
    private myRef: React.RefObject<HTMLDivElement>;
    private spanRef: React.RefObject<HTMLDivElement>;
    private animation: Animation | undefined;
    constructor(props: MessageProps) {
        super(props);
        this.myRef = React.createRef<HTMLDivElement>();
        this.spanRef = React.createRef<HTMLDivElement>();
        // this.animation = new Animation();
    }
    render() {
        return (
            <div className="message-container" style={{ width: this.props.width, maxWidth: this.props.width }}>
                <div ref={this.myRef} style={{ width: this.props.width, maxWidth: this.props.width, color: this.props.fontColor, textAlign: this.props.textAlign }}>
                    {/* we need to use 'dangerouslySetInnerHTML' for setting content which could contain html escaped characters like &#38; */}
                    <span ref={this.spanRef} dangerouslySetInnerHTML={{__html: this.props.content}}></span>
                </div>
            </div>
        );
    }
    componentDidMount() {
        if (this.measureWidthAndScrolling())
            this.startScrolling();
    }
    
    componentDidUpdate() {
        this.removeScrolling();
        if (this.measureWidthAndScrolling())
            this.startScrolling();
    }
    measureWidthAndScrolling() {
       
        let width: any = this.spanRef.current?.offsetWidth;
        let clientwidth = this.myRef.current?.clientWidth;
        if(clientwidth !== undefined)
            return clientwidth < width
    }
    startScrolling() {
        this.myRef.current?.setAttribute("class", "slide-container");
        var len = this.myRef.current?.innerHTML.length;
        if (len !== undefined && this.animation === undefined) {
            this.animation = this.myRef.current?.firstElementChild?.animate([
                // keyframes
                { transform: 'translateX(0)', offset: 0 },
                { transform: 'translateX(-100%)', offset: 1 }
            ], {
                // timing options
                duration: (len / 5) * 1000,
                iterations: Infinity,
            });
        }
        else
            this.animation?.play();
    }
    removeScrolling() {
        this.myRef.current?.removeAttribute("class");
        if (this.animation !== undefined)
            this.animation.pause();
    }
}